import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
// SharedModule removed to avoid circular dependency in demo
import { NgApexchartsModule } from 'ng-apexcharts';
import {  BiometricGuageComponent } from './biometric-guage.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    NgApexchartsModule,
    
  ],
  declarations: [BiometricGuageComponent],
  exports: [BiometricGuageComponent],
})
export class BiometricGuageModule {}


